<template>
  <v-card>
    <v-card-title>Communication Preferences</v-card-title>
    <v-divider/>
    <v-card-text>
      <v-alert v-if="alertBanner" type="success">{{ alertBanner }}</v-alert>
      <h3 class="mt-2 mb-2">Delivery Methods</h3>
      <v-divider class="mb-2"></v-divider>
      <v-form ref="communicationPreferencesForm" v-model="valid">
        <v-switch label="Email" v-model="emailDelivery"></v-switch>
        <v-row align="center">
          <v-col cols="4">
            <v-switch label="SMS" v-model="smsDelivery"></v-switch>
          </v-col>
          <v-col cols="8" v-if="smsDelivery">
            <number-field
              :options="{ type: `phone` }"
              placeholder="Mobile Number"
              v-model="cellNumberModel"
              :rules="[requiredRule]"
              v-on:phoneData="phoneDataChanged"
            />
          </v-col>
        </v-row>
        <p class="caption" v-if="smsDelivery">
          Text messages will originate from
          <strong>{{ getConfig('SMS_ORIGINATION_NUMBER') | toPhone }}</strong
          >. Please add this number to your contacts. Data rates may apply.
        </p>
        <h3 class="mt-2 mb-2">Subscription Categories</h3>
        <v-divider class="mb-2"></v-divider>
        <v-checkbox
          v-for="subscriptionCategory in [...getSubscriptionCategories].sort(
            this.alphaSort
          )"
          :key="subscriptionCategory.id"
          :label="subscriptionCategory.title"
          v-model="subscriptions"
          :value="subscriptionCategory.netsuite_internalId"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-divider class="mt-5"></v-divider>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        @click="submit()"
        color="primary"
        :loading="loading"
        :disabled="loading"
      >Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import orderMixin from '@/mixins/order'
import NumberField from '@/components/NumberField'

export default {
  components: {
    NumberField,
  },
  props: ['alertBanner', 'shown'],
  watch: {
    shown: {
      handler(val) {
        if (val) this.init()
      },
      deep: true,
    },
  },
  data: () => ({
    valid: null,
    loading: false,
    emailDelivery: null,
    smsDelivery: null,
    subscriptions: [],
    cellNumberModel: null,
    countryCode: null,
  }),
  mixins: [orderMixin],
  async mounted() {
    await this.init()
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getUserSubscriptions',
      'getSubscriptionCategories',
      'getConfig',
    ]),
  },
  methods: {
    requiredRule: (v) => !!v || 'This field is required',
    phoneDataChanged(data) {
      this.countryCode = (data.countryCallingCode) ? `+${data.countryCallingCode}` : undefined
    },
    async init() {
      await Promise.all([
        this.$store.dispatch('fetchSubscriptionCategories'),
        this.$store.dispatch('fetchProfile'),
        this.$store.dispatch('fetchUserSubscriptions')
      ])
      this.emailDelivery = this.getUserProfile.emailDelivery
      this.smsDelivery = this.getUserProfile.smsDelivery
      this.cellNumberModel = this.getUserProfile.cellnumber
      this.subscriptions = this.getUserSubscriptions
    },
    submit() {
      if (!this.$refs.communicationPreferencesForm.validate()) return
      this.loading = true
      const subscriptions = this.getSubscriptionCategories.map(
        (subscriptionCategory) => {
          return {
            id: subscriptionCategory.netsuite_internalId,
            subscribed:
              this.subscriptions.indexOf(
                subscriptionCategory.netsuite_internalId
              ) > -1,
          }
        }
      )
      this.$store
        .dispatch('updateCommunicationPreferences', {
          countryCode: this.countryCode,
          cellnumber: this.cellNumberModel,
          emailDelivery: this.emailDelivery,
          smsDelivery: this.smsDelivery,
          subscriptions,
        })
        .then(() => {
          this.loading = false
          window._VMA.$emit('SHOW_SNACKBAR', {
            text: 'Communication Preferences Saved',
            color: 'success',
          })
          window._VMA.$emit('CLOSE_COMMUNICATION_PREFERENCES')
          this.loading = false
        })
        .catch((err) => {
          window._VMA.$emit('SHOW_SNACKBAR', {
            text: err.response.data,
            color: 'error',
          })
          this.loading = false
        })
    },
  },
}
</script>
